import { createGlobalStyle } from 'styled-components';
import { fonts } from './fonts';

export const GlobalStyles = createGlobalStyle`
    ${fonts}

    /*
      Remove logo in Cookiebot dialog
    */
      #CybotCookiebotDialogPoweredbyCybot {
      display: none !important;
    }
    
    * { 
        box-sizing: border-box;
    }

    html, body{
        height:100%;
    }

    body {
        font-family: 'Avenir', sans-serif;
        padding: 0;
        margin: 0;
        background: ${({ theme }: any) => theme.colors.body};
        font-size: 16px;
        color: white;
    }
    h1, h2, h3, h4, h5, h6 {
        font-family: 'DomaineDispCondRegular', sans-serif;
        font-weight: 400;
        margin: 0px auto 20px;

    }
    h1 {
        font-size: 35px;
    

        @media all and (min-width: 600px) {
            font-size: 50px;
        }
    }

    h3 {
        font-size: 36px;

        @media all and (max-width: 450px) {
            font-size: 25px;
        }
    }
    h4 {
        font-size: 30px;

        @media all and (max-width: 450px) {
            font-size: 25px;
        }
    }
    p {
        &.ingress {
            font-family: 'DomaineText-Regular', 'Times New Roman', serif;
            font-size: 1.1em;
        }
    }

    a {
        color: ${({ theme }) => theme.colors.primary};
    }
    button, input, textarea {
        font-family: inherit;
    }

    .tox .tox-notification--warn,
    .tox .tox-notification--warning {
        display: none !important;
    }
`;
